import { render, staticRenderFns } from "./FilesViewField.vue?vue&type=template&id=3e4ce522&scoped=true&"
import script from "./FilesViewField.vue?vue&type=script&lang=ts&"
export * from "./FilesViewField.vue?vue&type=script&lang=ts&"
import style0 from "./FilesViewField.vue?vue&type=style&index=0&id=3e4ce522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ce522",
  null
  
)

export default component.exports